<template>
    <div>
        <div class="widget_heading">
            <h5>
                <i class="fa fa-filter" aria-hidden="true"></i>
                Filtros
            </h5>
        </div>
        <div class="widget_heading">
            <h5>
                <frontTag
                v-if="filtrosData.marca"
                :tagName="filtrosData.marca"
                @eraseTag="removeFilter('marca')" />
                <frontTag
                v-if="filtrosData.modelo"
                :tagName="filtrosData.modelo"
                @eraseTag="removeFilter('modelo')" />
                <frontTag
                v-if="filtrosData.linea"
                :tagName="filtrosData.linea"
                @eraseTag="removeFilter('linea')" />
                <frontTag
                v-if="filtrosData.caja"
                :tagName="get_tipo_caja(filtrosData.caja)"
                @eraseTag="removeFilter('caja')" />
                <frontTag
                v-if="filtrosData.combustible"
                :tagName="get_combustible(filtrosData.combustible)"
                @eraseTag="removeFilter('combustible')" />
                <frontTag
                v-if="filtrosData.precio"
                :tagName="get_precio(filtrosData.precio)"
                @eraseTag="removeFilter('precio')" />
                <frontTag
                v-if="filtrosData.estado_blindaje"
                :tagName="get_blindaje(filtrosData.estado_blindaje)"
                @eraseTag="removeFilter('estado_blindaje')" />
            </h5>
        </div>
        <div class="sidebar_filter">
            <dl role="listbox" v-if="filtrosData.marca == null">
                <div :class="{ init_filter: openMarca }">
                    <dt>Marca</dt>
                    <dd
                        v-for="(marca, index) in orderFilter(contadoresData.marcas)"
                        :key="index"
                    >
                        <a
                            class="ui-search-link"
                            @click="goFilter(marca.label, 'marca')"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">{{
                                marca.label
                            }}</span>
                            <span class="ui-search-filter-results-qty"
                                >({{ marca.qty }})</span
                            >
                        </a>
                    </dd>
                </div>
                <a
                    v-if="orderFilter(contadoresData.marcas).length > 6"
                    class="ui-search-link"
                    @click="openMarca = false"
                    href="javascript:void(0)"
                    >Ver todos</a
                >
            </dl>
            <dl role="listbox" v-if="filtrosData.modelo == null">
                <div :class="{ init_filter: openModelo }">
                    <dt>Modelo</dt>
                    <dd
                        v-for="(modelo, index) in orderFilter(contadoresData.modelos)"
                        :key="index"
                    >
                        <a
                            class="ui-search-link"
                            @click="goFilter(modelo.label, 'modelo')"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">{{
                                modelo.label
                            }}</span>
                            <span class="ui-search-filter-results-qty"
                                >({{ modelo.qty }})</span
                            >

                        </a>
                    </dd>
                </div>
                <dd class="price_filter_container">
                    <fieldset class="price-filter__fieldset">
                        <input
                            class="price-filter__value"
                            type="text"
                            placeholder="Minimo"
                            maxlength="4"
                            min="1"
                            onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                            v-model="modeloFrom"
                        />
                        <span class="price-filter__separator">-</span>
                        <input
                            class="price-filter__value"
                            type="text"
                            placeholder="Maximo"
                            maxlength="4"
                            min="1"
                            onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                            v-model="modeloTo"
                        />
                    </fieldset>
                    <a
                    @click="goFilter(modeloFrom+':'+modeloTo, 'modelo')"
                    style="margin: auto;" href="javascript:void(0)">
                        <span
                        class="angle_arrow"
                        style="background-color: #e0e0e0;"
                        >
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>

                    </a>
                </dd>
                <a
                    v-if="orderFilter(contadoresData.modelos).length > 6"
                    class="ui-search-link"
                    @click="openModelo = false"
                    href="javascript:void(0)"
                    >Ver todos</a
                >
            </dl>
            <dl role="listbox" v-if="filtrosData.linea == null">
                <div :class="{ init_filter: openLinea }">
                    <dt>Linea</dt>
                    <dd
                        v-for="(linea, index) in orderFilter(contadoresData.lineas)"
                        :key="index"
                    >
                        <a
                            @click="goFilter(linea.label, 'linea')"
                            class="ui-search-link"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">{{
                                linea.label
                            }}</span>
                            <span class="ui-search-filter-results-qty"
                                >({{ linea.qty }})</span
                            >
                        </a>
                    </dd>
                </div>
                <a
                    v-if="orderFilter(contadoresData.lineas).length > 6"
                    class="ui-search-link"
                    @click="openLinea = false"
                    href="javascript:void(0)"
                    >Ver todos</a
                >
            </dl>
            <dl role="listbox" v-if="filtrosData.estado_blindaje == null">
                <div :class="{ init_filter: openBlindaje }">
                    <dt>Blindaje</dt>
                    <dd
                        v-for="(blindaje, index) in orderFilter(contadoresData.estado_blindaje)"
                        :key="index"
                    >
                        <a
                            @click="goFilter(blindaje.label, 'estado_blindaje')"
                            class="ui-search-link"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">
                                {{ blindaje.label}}
                            </span>
                            <span class="ui-search-filter-results-qty"
                                >({{ blindaje.qty }})</span
                            >
                        </a>
                    </dd>
                </div>
            </dl>
            <dl role="listbox" v-if="filtrosData.caja == null">
                <div :class="{ init_filter: openCaja }">
                    <dt>Caja</dt>
                    <dd
                        v-for="(caja, index) in contadoresData.caja"
                        :key="index"
                    >
                        <a
                            @click="goFilter(index, 'caja')"
                            class="ui-search-link"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">{{
                                get_tipo_caja(index)
                            }}</span>
                            <span class="ui-search-filter-results-qty"
                                >({{ caja }})</span
                            >
                        </a>
                    </dd>
                </div>
                <a
                    v-if="contadoresData.caja.length > 6"
                    class="ui-search-link"
                    @click="openCaja = false"
                    href="javascript:void(0)"
                    >Ver todos</a
                >
            </dl>
            <dl
                class="init_filter"
                role="listbox"
                v-if="filtrosData.combustible == null"
            >
                <div :class="{ init_filter: openCombustible }">
                    <dt>Combustible</dt>
                    <dd
                        v-for="(combustible, index) in contadoresData.combustible"
                        :key="index"
                    >
                        <a
                            @click="goFilter(index, 'combustible')"
                            class="ui-search-link"
                            href="javascript:void(0)"
                        >
                            <span class="ui-search-filter-name">{{
                                get_combustible(index)
                            }}</span>
                            <span class="ui-search-filter-results-qty"
                                >({{ combustible }})</span
                            >
                        </a>
                    </dd>
                </div>
                <a
                    v-if="contadoresData.combustible.length > 6"
                    class="ui-search-link"
                    @click="openCombustible = false"
                    href="javascript:void(0)"
                    >Ver todos</a
                >
            </dl>
            <dl role="listbox" v-if="filtrosData.precio == null">
                <dt>Precio</dt>
                <dd>
                    <a class="ui-search-link"
                    @click="goFilter('0:25000000', 'precio')"
                    href="javascript:void(0)">
                        <span class="ui-search-filter-name" >Hasta $25.000.000</span >
                        <span class="ui-search-filter-results-qty">({{counterPrices([0, 25000000])}})</span>
                    </a>
                </dd>
                <dd>
                    <a class="ui-search-link"
                    @click="goFilter('25000000:35000000', 'precio')"
                    href="javascript:void(0)">
                        <span class="ui-search-filter-name" >$25.000.000 a $35.000.000</span >
                        <span class="ui-search-filter-results-qty">({{counterPrices([25000000, 35000000])}})</span>
                    </a>
                </dd>
                <dd>
                    <a class="ui-search-link"
                    @click="goFilter('35000000:50000000', 'precio')"
                    href="javascript:void(0)">
                        <span class="ui-search-filter-name" >$35.000.000 a $50.000.000</span >
                        <span class="ui-search-filter-results-qty">({{counterPrices([35000000, 50000000])}})</span>
                    </a>
                </dd>
                <dd>
                    <a class="ui-search-link"
                    @click="goFilter('50000000:300000000', 'precio')"
                    href="javascript:void(0)">
                        <span class="ui-search-filter-name" >Mas de $50.000.000</span >
                        <span class="ui-search-filter-results-qty">({{counterPrices([50000000, 300000000])}})</span>
                    </a>
                </dd>
                <dd class="price_filter_container">
                    <fieldset class="price-filter__fieldset">
                        <vue-autonumeric
                            class="price-filter__value"
                            type="text"
                            placeholder="Minimo"
                            onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                            :options="optionsNumeric"
                            v-model="preciosFrom"
                        ></vue-autonumeric>
                        <span class="price-filter__separator">-</span>
                        <vue-autonumeric
                            class="price-filter__value"
                            type="text"
                            placeholder="Maximo"
                            onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                            :options="optionsNumeric"
                            v-model="preciosTo"
                        ></vue-autonumeric>
                    </fieldset>
                    <a
                    @click="goFilter(preciosFrom+':'+preciosTo, 'precio')"
                    style="margin: auto;" href="javascript:void(0)">
                        <span
                        class="angle_arrow"
                        style="background-color: #e0e0e0;"
                        >
                            <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import frontTag from './frontTag';
export default {
    components: {
        frontTag
    },
    data() {
        return {
            openMarca: true,
            openModelo: true,
            openLinea: true,
            openCaja: true,
            openBlindaje: true,
            openCombustible: true,
            preciosFrom: 0,
            preciosTo: 0,
            modeloFrom: 0,
            modeloTo: 0,
            optionsNumeric: [
                "integerPos",
                {
                    digitGroupSeparator: ".",
                    decimalCharacter: ",",
                    minimumValue: '0',
                    maximumValue: '9999999999'
                }
            ]
        };
    },
    computed: {
        filtrosData() {
            return this.$store.state.buscador.filtroslocal;
        },
        contadoresData() {
            return this.$store.state.buscador.contadoreslocal;
        },
        inventarioData() {
            return this.$store.state.buscador.inventario;
        }
    },
    methods: {
        get_precio(code_precio, preciosFrom, preciosTo) {
            switch (code_precio) {
                case "0:25000000":
                    return "$0 - $25.000.000";
                    break;
                case "25000000:35000000":
                    return "$25.000.000 - $35.000.000";
                    break;
                case "35000000:50000000":
                    return "$35.000.000 - $50.000.000";
                    break;
                case "50000000:300000000":
                    return "$50.000.000 - $300.000.000";
                    break;
                case preciosFrom+':'+preciosTo:
                    return "dfd - sds";
                    break;
                default:
                    return code_precio;
            }
        },
        get_blindaje(code_blindaje) {
            switch (code_blindaje) {
                case "Si":
                    return "Blindado"
                    break;
                case "No":
                    return "Sin blindaje"
                default:
                    return code_blindaje;
            }
        },
        get_combustible(code_combustible) {
            switch (code_combustible) {
                case "GSL":
                    return "Gasolina";
                    break;
                case "DSL":
                    return "Diesel";
                    break;
                case "ELT":
                    return "Electrico";
                    break;
                case "HBD":
                    return "Híbrido";
                    break;
                default:
                    return code_combustible;
            }
        },
        get_tipo_caja(code_caja) {
            switch (code_caja) {
                case "AT":
                    return "Automatica";
                    break;
                case "MT":
                    return "Mecanica";
                    break;
                case "TP":
                    return "Triptonic";
                    break;
            }
        },
        orderFilter(itemsList) {
            var mapItems = _.map(itemsList, (item, index) => {
                return {
                    label: index,
                    qty: item
                }
            });
            var orderFilter = _.orderBy(mapItems, 'label', ["asc"]);
            return orderFilter;
        },
        counterPrices(between){
            var inventario = this.inventarioData;
            var pricesFilter = _.filter(inventario, (car) =>{
                return car.precio >= between[0] && car.precio <= between[1];
            });
            return pricesFilter.length;
        },
        goFilter(slug, param) {
            var params = new URLSearchParams(window.location.search);
            params.set(param, slug);
            window.location.href = `${window.location.pathname}?${params}`;
        },
        removeFilter(param){
            var params = new URLSearchParams(window.location.search);
            params.delete(param);
            window.location.href = `${window.location.pathname}?${params}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.init_filter {
    max-height: 165px;
    overflow: hidden;
}
dl {
    padding-right: 16px;
    margin-bottom: 30px;
}
dt {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 1.25;
    color: #333;
}
dd {
    font-size: 14px;
    font-weight: 300;
    margin: 0 0 6px;
}
.ui-search-link {
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;
}
.price_filter_container {
    display: flex;
    flex-wrap: wrap;
}
.price-filter__fieldset {
    display: flex;
    flex-wrap: wrap;
}
.ui-search-filter-name {
    color: #666;
    font-weight: 400;
    font-size: 14px;
    margin-left: 0;
    white-space: nowrap;
}
.ui-search-filter-results-qty {
    font-size: 14px;
    font-weight: 300;
    color: #999;
    margin-left: 6px;
}
.price-filter__value {
    border-radius: 4px;
    border: solid 1px #999;
    height: 30px;
    width: 65px;
    text-align: left;
    padding: 0 4px;
}
.price-filter__separator {
    margin: 0 5px;
    font-size: 20px;
}
</style>
